import { Component, NgZone, ChangeDetectionStrategy } from '@angular/core';

import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  template: `
    @if (loading) {
      <div class="loader-wrapper" role="status" aria-live="polite">
        <span class="loader-spinner" aria-hidden="true"></span>
        <span>Loading…</span>
      </div>
    }
    `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  loading = false;

  constructor(public loader: LoaderService, private ngZone: NgZone) {
    this.loader.loading$.subscribe((val) => {
      this.ngZone.run(() => {
        this.loading = val;
      });
    });
  }
}
